export default __webpack_public_path__ + "static/media/faceE.64cf6782.png";